var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":"","color":"#263238","dark":"","fixed":""}},[_c('v-toolbar-title',[_vm._v("DASHBOARD")]),_c('v-divider',{staticClass:"mx-2",attrs:{"inset":"","vertical":""}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }